// Module props
export const ROWS = 'ROWS';
export const CAROUSEL = 'CAROUSEL';
export const RELATED_STYLE_ONE = 'RELATED_STYLE_ONE';
export const RELATED_STYLE_TWO = 'RELATED_STYLE_TWO';
